import styled from "styled-components/macro";
import { Button } from "../../../../components";
import { media } from "../../../../utils";

export const ConsultarButton = styled(Button)`
  width: 100%;
`;

export const GrupoMesContent = styled.div`
  ${media.md()} {
    display: flex;
    justify-content: space-between;
  }
`;

export const InputGrupo = styled.input`
  ${media.md()} {
    width: 45%;
    input {
      width: 100%;
    }
  }
`;

export const SelectMes = styled.select`
  ${media.md()} {
    width: 45%;
  }
`;

export const CotaSorteada = styled.span({
  width: "100%",
  maxWidth: "48px",
  margin: "0 10px",
});

export const LabelQuantidadeContemplados = styled.span({
  width: "100%",
  textAlign: "center",
  marginBottom: "0",
  [media.lg()]: {
    textAlign: "left",
  },
});

export const ButtonContemplacao = styled.button({
  width: "100%",
  [media.lg()]: {
    maxWidth: "240px",
  },
});

export const ContentCotasSorteadas = styled.div({
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  margin: "0 -10px",
});

export const ContainerCotasSorteadas = styled.div({
  width: "100%",
  padding: "0 12px",
});

export const CotaBlock = styled.div({
  position: "relative",
});

export const CloseIcon = styled.img({
  position: "absolute",
  right: "20px",
  top: "54px",
  cursor: "pointer",
});
